import { render } from "./SectionPLV.vue?vue&type=template&id=3e5fb635&scoped=true"
import script from "./SectionPLV.vue?vue&type=script&lang=js"
export * from "./SectionPLV.vue?vue&type=script&lang=js"

import "./SectionPLV.vue?vue&type=style&index=0&id=3e5fb635&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5fb635"]])

export default __exports__